module.exports = __webpack_public_path__ + "static/pic01@3x-c0960460f0ea1a7e925137db57e47d3a.jpg";